// extracted by mini-css-extract-plugin
export default {"main":"DataField_main__N3U6O","name":"DataField_name__gn59Y","data":"DataField_data__fU40N"};